var exports = {
  "k": "container__1MF1B1",
};

module.exports = exports;
